import makeStyles from '@mui/styles/makeStyles';

const warningConfirmModalStyles = makeStyles((theme) => {
    return {
        root: {
            padding: theme.spacing(3, 4)
        },
        dialogPaper: {
            '& .MuiPaper-root': {
                height: 'auto',
                borderRadius: 12,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                maxWidth: 420,
                overflow: 'hidden'
            }
        },
        title: {
            fontWeight: 600,
            fontSize: '0.9rem',
            lineHeight: 1.4,
            color: theme.palette.text.primary
        },
        subtitle: {
            fontSize: '0.82rem',
            lineHeight: 1.5,
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.25)
        },
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: theme.spacing(1),
            marginTop: theme.spacing(2.5),
            padding: 0
        },
        cancelButton: {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.82rem',
            color: theme.palette.grey[980] || '#6b6b80',
            padding: theme.spacing(0.75, 2),
            '&:hover': {
                backgroundColor: theme.palette.grey[920] || '#f4f4f8'
            }
        },
        confirmButton: {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.82rem',
            padding: theme.spacing(0.75, 2.5),
            borderRadius: 6
        }
    };
});

export default warningConfirmModalStyles;
